import { BlacklistedProductsResponse } from '@/types/blacklistedProducts'
import { defineStore } from 'pinia'

interface States {
  blacklistedProducts: Ref<BlacklistedProductsResponse | null>
}

export const useBlacklistedProductsStore = defineStore('blacklistedProducts', () => {
  const states: States = {
    blacklistedProducts: ref(null),
  }

  const resetStore = () => {
    states.blacklistedProducts.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
